import { metrics } from '@atlassian/browser-metrics';

export const projectArchivedPageLoad = metrics.pageLoad({
	key: 'project-archived',
	ssr: {
		doneAsFmp: true,
	},
});
